var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"my-ui-xxbb-my-form-item-body"},[_c('div',{staticClass:"my-ui-xxbb-my-form-item-label"},[_vm._v(_vm._s(_vm.label)),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.required),expression:"required"}],staticClass:"my-ui-xxbb-my-form-item-required"},[_vm._v("*")])]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }